import axios from 'api';
import { IUser } from 'redux/user/user.types';

const url = '/api/users';

const UserAPI = {
  getAll: (params: string) => axios.get(url + params),
  getOne: (id: string) => axios.get(`${url}/${id}`),
  create: (data: Partial<IUser>) => axios.post(url, data),
  update: (data: Partial<IUser>) => axios.patch(`${url}/${data._id}`, data),
  delete: (id: string) => axios.delete(`${url}/${id}`),
};

export default UserAPI;
